// LOCAL: placeholder section under StoreLayout — not implemented yet.
import { Card } from 'corso-admin-ui';
import { Mono, Section } from './RetoolPlaceholder';
import { StorePage } from './StorePage';

export default function SupportSlaPage() {
  return (
    <StorePage title="Support SLA">
      <Card>
        <Card.Heading as="h2">Support SLA</Card.Heading>
        <Card.Description>
          Drives the “SLA” badge / copy that surfaces in support tooling so
          Concierge knows what they’ve signed up to. Placeholder — wire up when
          the data lands.
        </Card.Description>

        <Section heading="Form values / controls">
          <p>
            TextAreaInput <Mono>sla</Mono> — response-time commitments,
            escalation path, business-hours coverage. Free-form prose today.
          </p>
          <p>
            (Future) split into structured fields per SLA tier when we model it.
          </p>
        </Section>

        <Section heading="Reads">
          <p>
            <Mono>STORE_SLA</Mono> — the current SLA text from{' '}
            <Mono>Store.sla</Mono>.
          </p>
        </Section>

        <Section heading="Mutations">
          <p>
            Save → <Mono>ADD_UPDATE_SLA</Mono> Hasura <Mono>update_Store</Mono>{' '}
            setting <Mono>sla</Mono> on the current store row.
          </p>
        </Section>
      </Card>
    </StorePage>
  );
}
